module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-apotheek-rodenbach-machelen-zulte-4.5c928321.jpg";